export const appleMobileRegex = /iphone|ipad|ipod/i;

export const androidRegex = /android/i;

// Simple heuristics to detect actual mobile devices (not just any device that has a touch screen). Won't work for every mobile device, this isn't very extensive, so avoid using for critical stuff.
export const commonMobileRegex = /iphone|ipad|ipod|android/i;

// This should heuristically match the values that the most common crawlers / non-malicious bots send in their user agent headers, without causing false positives on normal browsers (none of the regex options should appear as substrings in normal browser UAs)
// Just generic terms such as words ending with "bot" match most bots, but some services use special snow flake user agents that need to be targeted specifically. We include most importantly services that may crawl our site for advertising purposes. Here's some background:
// - "google" is used by some google crawlers that don't include the word "bot". Chrome etc browsers thankfully *don't* include this term.
// - "bing" is included since it's a common search crawler
// - Meta advertising is used by us, and their ad-related crawlers should start with the "meta-" string
export const commonBotRegex =
	/bot\b|crawl|spider\b|scrape|google|bing|\bmeta-/i;
